import { jsonEmptyContentState } from 'Shared/utils/draftJsHelpers';
import { v4 as uuidv4 } from 'uuid';

export function generateTempItem({
  position,
  parentId,
  parentUuid,
  body = jsonEmptyContentState(),
  itemUuid = uuidv4(),
  isAssignCurrentUser = true,
  isSection = false,
  isHighPriority = false,
  user,
  itemType = 'action_item',
  associatedMeetingItemId = null,
  workspaceId,
  positionForActionItemsPage = null,
  positionForHomePage = null,
  positionForGoalDetailPage = null,
  assignmentInfo = {},
  dueBy,
  asanaData = null,
  servicenowData = null,
  goalSlug,
  reviewSlug,
  meetingTranscriptionSlug,
}) {
  const assignmentPersonId = () => {
    if (isAssignCurrentUser) return user.person.id;
    if (assignmentInfo.assigneePersonId) return assignmentInfo.assigneePersonId;
    return null;
  };
  const assignmentAvatar = () => {
    if (isAssignCurrentUser) return user.avatar;
    if (assignmentInfo.assigneeAvatar) return assignmentInfo.assigneeAvatar;
    return null;
  };
  const assignee = () => {
    if (isAssignCurrentUser) {
      return { userId: user.id, personName: user.full_name || user.email };
    }
    if (assignmentInfo.assigneeName && assignmentInfo.assigneeUserId) {
      return { userId: assignmentInfo.assigneeUserId, personName: assignmentInfo.assigneeName };
    }
    return { userId: null, personName: null };
  };
  const assigner = () => {
    if (isAssignCurrentUser) {
      return { userId: user.id, personName: user.full_name || user.email };
    }
    if (assignmentInfo.assignerName && assignmentInfo.assignerUserId) {
      return { userId: assignmentInfo.assignerUserId, personName: assignmentInfo.assignerName };
    }
    return { userId: null, personName: null };
  };
  return {
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    completed: false,
    position,
    parentId,
    parentUuid,
    attachments: [],
    body,
    isHighPriority,
    isSection,
    uuid: itemUuid,
    assignmentPersonId: assignmentPersonId(),
    assignmentAvatar: assignmentAvatar(),
    user,
    comments: [],
    history: [],
    itemType,
    workspaceId,
    associatedMeetingItemId,
    positionForActionItemsPage,
    positionForHomePage,
    positionForGoalDetailPage,
    assignee: assignee(),
    assigner: assigner(),
    dueBy,
    asanaData,
    servicenowData,
    goalSlug,
    reviewSlug,
    meetingTranscriptionSlug,
  };
}

export function itemWithFieldsForCreate({ body, uuid, parentId, workspaceId, position, user, itemType }) {
  return {
    body,
    uuid,
    parentId,
    workspaceId,
    position,
    user,
    itemType,
    assignment_attributes: {
      personId: user.person.id,
      userId: user.id,
    },
  };
}

export function generateFormDataFromItem(item) {
  const data = new FormData();
  data.append('item[body]', item.body);
  data.append('item[workspace_id]', item.workspaceId);
  data.append('item[uuid]', item.uuid);
  data.append('item[is_section]', item.isSection);
  if (item.parentId) data.append('item[parent_id]', item.parentId);
  if (item.associatedMeetingItemId) data.append('item[associated_meeting_item_id]', item.associatedMeetingItemId);
  data.append('item[item_type]', item.itemType);
  if (item.dueBy) data.append('item[due_by]', item.dueBy);
  data.append('item[position]', item.position);
  data.append('item[position_for_home_page]', item.positionForHomePage);
  data.append('item[position_for_action_items_page]', item.positionForActionItemsPage);
  data.append('item[position_for_goal_detail_page]', item.positionForGoalDetailPage);
  data.append('item[goal_id]', item.goalId);
  data.append('item[goal_slug]', item.goalSlug);
  data.append('item[review_slug]', item.reviewSlug);

  if (item.assignmentPersonId) {
    data.append('item[assignment_attributes][person_id]', item.assignmentPersonId);
    data.append('item[assignment_attributes][user_id]', item.user.id);
  }

  return data;
}
